/* eslint-disable no-unused-vars */
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Typography,
  makeStyles,
  colors
} from '@material-ui/core';
import InsertChartIcon from '@material-ui/icons/InsertChartOutlined';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.orange[600],
    height: 56,
    width: 56
  },
  differenceIcon: {
    color: colors.orange[600]
  },
}));

const RejectedClients = ({ className, RejectedArray, RejectedArrayPercentage, totalArray, ...rest }) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              REJECTED CLIENTS
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {totalArray === 0 ? '......' : RejectedArray}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <PeopleOutlineIcon />
            </Avatar>
          </Grid>
        </Grid>
        <Box
          mt={2}
          display="flex"
          alignItems="center"
        >
          <ArrowUpwardIcon className={classes.differenceIcon} />
          <Typography
            className={classes.differenceValue}
            variant="body2"
          >
            {totalArray === 0 ? '......' : RejectedArrayPercentage.toFixed(2)}% &nbsp;
          </Typography>
          <Typography
            color="textSecondary"
            variant="caption"
          >
            Of total submitted forms
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

RejectedClients.propTypes = {
  className: PropTypes.string
};

export default RejectedClients;
